<template>
  <component :is="componentType" :to="to" v-bind="resetProps" :v-on="$listeners" class="app-link">
    <slot name="prepend" />
    <span class="link">{{ title }}</span>
    <slot name="append" />
  </component>
</template>

<script>
import Vue from "vue";

const AppLink = Vue.extend({
  name: "AppLink",

  data: () => ({
    componentType: "span",
  }),

  props: {
    title: {
      required: true,
      default: "",
      type: String,
    },

    to: {
      default: null,
      type: [String, null],
    },
  },

  mounted() {
    if (!!this.to) {
      this.componentType = "router-link";
    }
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },
});
export default AppLink;
</script>

<style lang="scss" scoped>
.app-link {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  max-height: 100%;
  text-decoration: none;
  color: var(--v-primary-base);
  font-size: 1.5rem;
  .link {
    text-decoration: underline;
    cursor: pointer !important;
  }
}
</style>
